import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';

import Tab from 'react/containers/layout/tabs/Tab';
import { AutorizationCredentialList } from './AutorizationCredentialList';
import AutorizationCredentialForm from './AuthorizationCredentialForm';

class AuthorizationCredential extends Tab {
  static propTypes = {
    active: PropTypes.bool
  }

  static tabName = 'AuthorizationCredential'

  activeClassName = 'is-active'

  getParametersFromPathName() {
    const { tab: { extra, pathname } } = this.props;
    const parentId = extra ? extra.parentId : null;
    const { length } = pathname.split('/');
    const index = (length - 2) + (length % 2);
    const [mode, id] = pathname.split('/').slice(index);

    return { mode, id, parentId };
  }

  render() {
    const { active } = this.props;
    const { id } = this.getParametersFromPathName();

    const className = `gmTabs__panel ${(active) ? this.activeClassName : ''}`;

    return (
      <div id="AuthorizationCredential" className={className}>
        <Switch>
          <Route exact path="/AuthorizationCredential" component={AutorizationCredentialList} />
          <Route path="/AuthorizationCredential/new" component={() => <AutorizationCredentialForm />} />
          <Route path="/AuthorizationCredential/edit/:id" component={() => <AutorizationCredentialForm id={id} />} />
        </Switch>
      </div>
    );
  }
}

export default AuthorizationCredential;
